import React from 'react';

const CarouselIcon = ({
  color = '#FF8A1F',
  size = 12,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M0 11.1111H8.88889V0H0V11.1111ZM0 20H8.88889V13.3333H0V20ZM11.1111 20H20V8.88889H11.1111V20ZM11.1111 0V6.66667H20V0H11.1111Z" fill={color} />
    </svg>
  );
};

export default CarouselIcon;
